module.exports = __webpack_public_path__ + "static/experience_scene2-e93e797a28cc8cfbd7369311802ed575.svg";